import * as React from "react";
import { IDocumentModel } from "./IDocumentModel";
import { getFileExtension, bytesToSize } from "./Helper/HelperFunctions";
import { FileFormatIcon } from "../../assets/images/svg/FileIconCollection";
import ProgressBar from "react-bootstrap/ProgressBar";
interface DocumentItemProps {
    document: IDocumentModel;
    index: number;
    onRemoveAttachment: (guid: string) => void;
}

const DocumentItem: React.FC<DocumentItemProps> = ({ document, index, onRemoveAttachment }) => {
    const documentName = document.displayName ?? document.name;
    return (
        document && (
            <div className="document-item-row-wrapper" key={index}>
                <div className="file-icon-name-wrapper">
                    <FileFormatIcon extension={getFileExtension(document.name)} width={35} height={35} />
                    <p className="truncate" title={documentName}>
                        {documentName}
                    </p>
                </div>

                <div>
                    {document.progressBar == 1 ? (
                        <p className="uploaded-btn">Uploaded</p>
                    ) : (
                        <ProgressBar striped variant="success" now={document.progressBar * 100} />
                    )}
                    <p className="size-text">{bytesToSize(document.size)}</p>

                    <p
                        className={`text-danger ${document.isUploaded ? "pointer" : "cursor-disabled"}`}
                        onClick={() => onRemoveAttachment(document.guid)}
                    >
                        <i className="fas fa-times"></i>
                    </p>
                </div>
            </div>
        )
    );
};

export default DocumentItem;
